import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaShoppingCart, FaCheck, FaStar } from 'react-icons/fa';
import { GiMilkCarton } from 'react-icons/gi';
import { useCart } from '../../context/CartContext';
import DecorativeHeading from '../../components/DecorativeHeading/DecorativeHeading';
import styles from './Products.module.css';
import { products } from '../../data/products';

const Products = () => {
  const { addToCart } = useCart();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.products}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>Our Products</h1>
          <p className="gujarati-text">અમારા ઉત્પાદનો</p>
          <p className={styles.subtitle}>Pure Gir Cow Bilona Ghee in Different Sizes</p>
        </div>
      </section>

      <section className={`${styles.productsSection} texture-bg`}>
        <div className="container">
          <div className={styles.highlights}>
            <div className={styles.highlight}>
              <FaCheck /> Free Delivery on Orders Above ₹1000
            </div>
            <div className={styles.highlight}>
              <FaCheck /> Farm to Home Packaging
            </div>
            <div className={styles.highlight}>
              <FaCheck /> COD Available
            </div>
          </div>

          <div className={styles.productsGrid}>
            {products.map((product, index) => (
              <motion.div
                key={product.id}
                className={`${styles.productCard} ${product.popular ? styles.popular : ''}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
              >
                {product.popular && (
                  <div className={styles.popularBadge}>
                    <FaStar /> Most Popular
                  </div>
                )}

                <Link to={`/products/${product.id}`} className={styles.productImageLink}>
                  <div className={styles.productImage}>
                    <img src={product.images[0]} alt={product.name} className={styles.productImg} />
                    <div className={styles.shine}></div>
                  </div>
                </Link>

                <div className={styles.productInfo}>
                  <h3>{product.name}</h3>
                  <p className={`${styles.gujaratiName} gujarati-text`}>{product.gujarati}</p>

                  <div className={styles.features}>
                    {product.features.map((feature, idx) => (
                      <span key={idx} className={styles.feature}>
                        <GiMilkCarton /> {feature}
                      </span>
                    ))}
                  </div>

                  <div className={styles.priceSection}>
                    <div className={styles.price}>
                      <span className={styles.currency}>₹</span>
                      <span className={styles.amount}>{product.price}</span>
                      <span className={styles.size}>/ {product.size}</span>
                    </div>
                  </div>

                  <div className={styles.actionButtons}>
                    <Link to={`/products/${product.id}`}>
                      <button className={styles.viewDetailsBtn}>
                        View Details
                      </button>
                    </Link>

                    <button
                      className={styles.addToCartBtn}
                      onClick={() => addToCart(product, 1)}
                    >
                      <FaShoppingCart /> Add to Cart
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className={styles.infoSection}>
            <DecorativeHeading variant="gold" gujaratiText="અમારું ઘી કેમ ખાસ છે">
              Why Our Ghee is Special
            </DecorativeHeading>
            <div className={styles.infoGrid}>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>🐄</span>
                <h4>Pure Gir Cow Milk</h4>
                <p>Made from indigenous Gir cow's A milk</p>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>🥄</span>
                <h4>Traditional Bilona Method</h4>
                <p>Hand-churned using wooden bilona</p>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>🌿</span>
                <h4>100% Natural</h4>
                <p>No chemicals, preservatives or additives</p>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>🏡</span>
                <h4>Farm Fresh</h4>
                <p>Directly from our farm to your home</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;

